<script setup lang="ts">

</script>

<template>
    <aeg-icon icon="pi pi-refresh" />
</template>

<style scoped lang="scss">

</style>
